export { BrowsePrimitivesPrimaryControlsStripExpansionContent } from "#browse-primitives-primary-controls-strip-expansion-content";
